module.exports = __webpack_public_path__ + "img/6.d6008676.png";